var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHorizontalArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "48px",
    viewBox: "0 0 44 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Horizontal Arrow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "System-Icon-/-Action-Arrow-/-Horizontal",
    transform: "translate(-2.000000, 0.000000)",
    fill: "#073C50"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Horizontal-Arrow",
    points: "22.132393 0 17.4627952 4.69549994 33.0029722 20.3218778 2 20.3218778 2 27.6789003 33.0025853 27.6785112 17.4627952 43.3045001 22.132393 48 46 24"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalArrow);
export default __webpack_public_path__ + "static/media/HorizontalArrow.c0fe82f089745bc59958ca0500693ec0.svg";
export { ForwardRef as ReactComponent };